<template>
  <div>
    <v-btn :to="{ name: 'OfficeUser' }" color="primary" plain>
      <v-icon left>fa-arrow-left</v-icon>
      ย้อนกลับ
    </v-btn>

    <v-container style="max-width: 1000px">
      <v-text-field
        v-model="userSearch"
        label="ค้นหา: รหัส, username, ชื่อ, สกุล"
        prepend-inner-icon="fa-magnifying-glass"
        solo
        dense
        @keyup="onSearchUser"
      ></v-text-field>
      <v-data-table
        :loading="userLoading"
        :headers="userHeaders"
        :items="users"
        :items-per-page="100"
        sort-by="id"
        :footer-props="{
          itemsPerPageOptions: [25, 50, 75, 100, -1],
        }"
      >
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            color="primary"
            title="เพิ่มผู้ใช้งาน"
            small
            @click="addUser(item)"
          >
            <v-icon left> fa-plus </v-icon>
            เพิ่ม
          </v-btn>
        </template>
      </v-data-table>
    </v-container>

    <DialogCreateUser :dialog.sync="dialogCreateUser" :user="showUser" :roles="roles" />
  </div>
</template>

<script>
import * as PersonnelService from "@/common/service/personnel.service"
import * as UserService from "@/common/service/user.service"
import * as RoleService from "@/common/service/role.service"
import _ from "lodash"

import { UPDATE_BREADCRUMBS } from "@/store/action.type"
import { ALREADY_USER } from "@/common/consistent"
import { swalFire } from "@/common/alert"
import { ChipRole } from "@/components/chip"
import { DialogCreateUser } from "@/components/dialog"

export default {
  name: "OfficeUserCreate",
  title: "เพิ่มผู้ใช้งาน",
  components: {
    DialogCreateUser,
    ChipRole,
  },
  created() {
    this.$store.dispatch(UPDATE_BREADCRUMBS, [
      {
        text: "ผู้ใช้งาน",
        disabled: false,
        exact: true,
        to: { name: "OfficeUser" },
      },
      {
        text: "เพิ่มผู้ใช้งาน",
        disabled: true,
        exact: true,
        to: { name: "OfficeUserCreate" },
      },
    ])
  },
  data() {
    return {
      userSearch: "",
      userHeaders: [
        { text: "ID", value: "id" },
        { text: "รหัส", value: "code" },
        { text: "username", value: "username" },
        { text: "ชื่อ - สกุล", value: "full_name" },
        { text: "ตัวเลือก", value: "actions" },
      ],
      userLoading: false,
      users: [],
      roles: [],

      showUser: {},
      dialogCreateUser: false,
    }
  },
  mounted() {
    this.getRole()
  },
  methods: {
    async getRole() {
      const res = await RoleService.index()
      this.roles = res.roles
    },
    onSearchUser: _.debounce(function () {
      this.searchUser()
    }, 500),
    async searchUser() {
      this.userLoading = true
      const res = await PersonnelService.index(`?search=${this.userSearch}`)
      this.users = res.personnels
      this.userLoading = false
    },
    async addUser(user) {
      const res = await UserService.exists(user.username)

      if (res.result) {
        swalFire("warning", ALREADY_USER)
      } else {
        this.dialogCreateUser = true
      }

      this.showUser = user
    },
  },
}
</script>
